<div class="not-found-page">
  <img class="not-found-page__cloud not-found-page__cloud--1" src="/assets/img/404/cloud-1.svg" alt="" aria-hidden="true" />
  <img class="not-found-page__cloud not-found-page__cloud--2" src="/assets/img/404/cloud-2.svg" alt="" aria-hidden="true" />
  <img class="not-found-page__cloud not-found-page__cloud--3" src="/assets/img/404/cloud-1.svg" alt="" aria-hidden="true" />
  <img class="not-found-page__cloud not-found-page__cloud--4" src="/assets/img/404/cloud-2.svg" alt="" aria-hidden="true" />

  <div class="not-found-page__content">
    <img class="not-found-page__illustration" src="/assets/img/404/jenzen-oops.png" alt="Oops" />
    <h1 class="not-found-page__title">404</h1>
    <p class="not-found-page__message" [innerHTML]="message"></p>
  </div>

  <img class="not-found-page__cityscape" src="/assets/img/404/cityscape.png" alt="" aria-hidden="true" />
</div>
